/* eslint-disable */
import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Alert from 'react-s-alert';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
// import useFormValidator from 'useFormValidator';
import CollectionsAndRemittancesModal from '../modal/CollectionsAndRemittancesModal'

import { InputTemplate } from "../../../../common/components/inputComponents";

import * as c from '../../constant';
import * as action from '../../action';

const CollectionsAndRemittances = ({ generateMiscFeeReport, isGenerating }) => {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(c.FORMS)

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  // const validateForm = useFormValidator(formData, {
  //   date_from: 'required',
  //   date_to: 'required',
  // });

  const checkDateFormat = (date='') => `${moment(new Date(date)).format('YYYY/MM/DD')}`

  const handleSubmit = e => {
    if (checkDateFormat(_.get(formData, 'date_from')) > checkDateFormat(_.get(formData, 'date_to'))) {
      Alert.warning('Invalid filter, Date From is greater than selected Date To');
      setFormData({ ...formData, date_from: '' });
    }

    const newData = {
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
    };

    e.preventDefault();
    generateMiscFeeReport(newData, () => {
      setModal({
        isOpen: true,
        content: (
          <CollectionsAndRemittancesModal
            newData={newData}
          />
        ),
        title: `Generated Remittance Report`,
        modalSize: 'modal-xl',
      });
    })
  }

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="my-4">
      <div className="misc-fee-container px-4 pb-4 pt-2">
        <div className="full-group-v2">
          <div className="form-row justify-content-center">
            <InputTemplate
              title="Export Date From"
              htmlFor="date_from"
              containerClassName="col-5"
              // formValidatorMsg={validateForm.renderMessage("date_from")}
              withCustomInputComponent={() => (
                <DateInputPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="MM/DD/YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-primary cms-outline-primary"
                  onChange={handleOnChangeDate('date_from')}
                  value={_.get(formData, 'date_from') || ''}
                />
              )}
            />
            <InputTemplate
              title="Export Date to"
              htmlFor="date_to"
              containerClassName="col-5"
              // formValidatorMsg={validateForm.renderMessage("date_to")}
              withCustomInputComponent={() => (
                <DateInputPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="MM/DD/YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-primary cms-outline-primary" 
                  onChange={handleOnChangeDate('date_to')}
                  value={_.get(formData, 'date_to') || ''}
                />
              )}
            />
            <div className="d-flex align-items-end mx-2 mb-1">
              <button
                disabled={_.get(formData, 'date_from') === '' || _.get(formData, 'date_to') === ''}
                type="submit"
                className="btn btn-primary"
                style={{ height: '43px' }}
              >
                {isGenerating ? <i className="fas fa-spinner fa-spin fa-lg ml-2" /> : <i className="fas fa-download" />}
                &nbsp;&nbsp;Generate
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

CollectionsAndRemittances.defaultProps = {
  isGenerating: false
}

CollectionsAndRemittances.propTypes = {
  generateMiscFeeReport: PropTypes.instanceOf(Function).isRequired,
  isGenerating: PropTypes.bool,
};

const mapStateToProps = ({ api }) => ({
isGenerating: _.get(api, 'loading', []).indexOf(c.GENERATE_MISC_FEE_REPORT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(CollectionsAndRemittances);
